import React from 'react';
import { CartProvider } from './Cart';
import { OptimisticProvider } from './Optimistic';
export const Provider = ({ mode = 'pure', onValidateCart, children, ...cartProps }) => (React.createElement(CartProvider, { ...cartProps }, mode === 'optimistic' ? (React.createElement(OptimisticProvider, { onValidateCart: onValidateCart }, children)) : (children)));
//# sourceMappingURL=Provider.js.map